// import _ from 'lodash'
import {
  READ_CONFIGS,
  CREATE_CONFIG,
  DELETE_CONFIG,
  UPDATE_CONFIG,
} from "../actions";

const issues = (state = [], action) => {
  switch (action.type) {
    case READ_CONFIGS:
      return action.response.data.listRedmineConfigs.items;
    case CREATE_CONFIG:
      return [...state, action.response.data.createRedmineConfig];
    case DELETE_CONFIG:
      const deleteConf = action.response.data.deleteRedmineConfig;
      const newList = state.filter((config) => config.id !== deleteConf.id);
      return newList;
    case UPDATE_CONFIG:
      const updateConf = action.response.data.updateRedmineConfig;
      const updateList = state.map((config) => {
        if (config.id === updateConf.id) return updateConf;
        return config;
      });
      return updateList;
    default:
      return state;
  }
};

export default issues;
